var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"login-form"},[_c('v-container',{staticClass:"pa-4"},[_c('h4',{staticClass:"headline text-center mb-3 font-weight-light text-capitalize"},[_vm._v(" "+_vm._s(_vm.$t('auth.login'))+" ")]),_c('login-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }